import React from 'react';
import Tooltip from '../../../../../Basic/Tooltip';
import { RequestStatusEnum, RequestSolutionOriginEnum } from "../types";

function SolutionsResult(props) {
  var _request$requestedSol3, _request$requestedSol4, _request$requestedSol5;

  var prefix = props.prefix,
      translate = props.translate,
      request = props.request;
  var componentClass = "".concat(prefix, "-user-request-modal");

  var generateTooltip = function generateTooltip() {
    var _request$requestedSol, _request$requestedSol2;

    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
      className: "".concat(componentClass, "-solution-list-item ").concat(componentClass, "-solution-list-item-bold")
    }, request.status === RequestStatusEnum.approved && translate('SFxAccountSettingsApprovedBy', request.modifiedByFullName), request.status === RequestStatusEnum.rejected && translate('SFxAccountSettingsRejectBy', request.modifiedByFullName)), (_request$requestedSol = request.requestedSolutions) === null || _request$requestedSol === void 0 ? void 0 : (_request$requestedSol2 = _request$requestedSol.filter(function (solution) {
      return filterSolution(solution, request.status);
    })) === null || _request$requestedSol2 === void 0 ? void 0 : _request$requestedSol2.map(function (solution) {
      return /*#__PURE__*/React.createElement("p", {
        key: solution.solutionId,
        className: "".concat(componentClass, "-solution-list-item")
      }, " ", generateSolutionRole(solution, request.status));
    }));
  };

  return /*#__PURE__*/React.createElement(Tooltip, {
    trigger: "hover",
    placement: "bottom",
    content: generateTooltip()
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(componentClass, "-solution-all")
  }, (_request$requestedSol3 = request.requestedSolutions) === null || _request$requestedSol3 === void 0 ? void 0 : (_request$requestedSol4 = _request$requestedSol3.filter(function (solution) {
    return filterSolution(solution, request.status);
  })) === null || _request$requestedSol4 === void 0 ? void 0 : (_request$requestedSol5 = _request$requestedSol4.map(function (solution) {
    return generateSolutionRole(solution, request.status);
  })) === null || _request$requestedSol5 === void 0 ? void 0 : _request$requestedSol5.join(', ')));
}

function filterSolution(solution, status) {
  if (status === RequestStatusEnum.approved && solution.status === status) return true;

  if (status === RequestStatusEnum.rejected && solution.origin === RequestSolutionOriginEnum.requested) {
    return true;
  }

  return false;
}

function generateSolutionRole(solution, status) {
  var _roles$;

  var result = solution.solutionName;
  var roles = getRoles(solution, status);

  if (Array.isArray(roles) && (_roles$ = roles[0]) !== null && _roles$ !== void 0 && _roles$.roleName) {
    var _roles$2;

    result = result + ' - ' + ((_roles$2 = roles[0]) === null || _roles$2 === void 0 ? void 0 : _roles$2.roleName);
  }

  return result;
}

function getRoles(solution, status) {
  if (status === RequestStatusEnum.approved) {
    return solution.finalSolutionRoles;
  }

  if (status === RequestStatusEnum.rejected) {
    return solution.requestedSolutionRoles;
  }

  return [];
}

export default SolutionsResult;